/** When parsing search params and performing operations like replacing, rending to view,
 * or clearing from URL, these are often supposed to persist after clear operation, so, it's helpful
 * to capture them in a reusable constant */
export const searchParamIgnoreArray = ['orderBy', 'ordering', 'page', 'itemsPerPage', 'splitIndex']
